<div class="system-notice">
  <i class="icon-warning icon-white system-notice__icon"></i>

  <div class="system-notice__text">
    <div class="system-notice__title" data-testid="system-notice-title">{{ data.notice.Title }}</div>
    <div class="system-notice__message" data-testid="system-notice-message">{{ data.notice.Description }}</div>
  </div>

  @if (data.notice.MoreInfo) {
    <button type="button"
            class="system-notice__more-info"
            data-testid="system-notice-more-info"
            [disabled]="isDismissing"
            (click)="data.onMoreInfo()"
            rtI18n>More Info</button>
  }

  <button type="button"
          class="system-notice__dismiss"
          aria-label="Dismiss notice"
          data-testid="system-notice-dismiss"
          [disabled]="isDismissing"
          (click)="dismiss()">
    <i class="icon-x icon-white"></i>
  </button>
</div>
